import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Tab } from "@headlessui/react";
import { motion } from "framer-motion";

import CustomerProfileView from "../components/Customer/ProfileView.js";
import CustomerServiceView from "../components/Customer/ServiceView.js";
import CustomerInvoiceView from "../components/Customer/InvoiceView.js";
import BillableItemList from "../components/Customer/BillableItemList.js";
import CustomerCreditLogsVieww from "../components/Customer/CreditView.js";
import CustomerTransactionView from "../components/Customer/TransactionView.js";
import CustomerLogView from "../components/Customer/LogsView.js";
import CustStickyNote from "../components/Customer/CustStickyNote.js";

export default function CustomerDetail({ role }) {
  const { cust_id } = useParams();
  const [token] = useState(() => localStorage.getItem("token"));

  const tabs = [
    "Profile",
    "Service",
    "Invoice",
    "Billable",
    "Credit",
    "Transaction",
    "Log",
  ];

  return (
    <div className="p-6 max-w-4xl mx-auto transition-colors duration-300 dark:bg-gray-900 dark:text-white">
      <CustStickyNote userId={cust_id} token={token} />
      <Tab.Group>
        {/* ======== TAB HEADER ======== */}
        <Tab.List className="flex space-x-2 overflow-x-auto bg-gray-200 dark:bg-gray-800 p-2 rounded-xl sticky top-0 z-20 shadow-md">
          {tabs.map((tab) => (
            <Tab
              key={tab}
              className={({ selected }) =>
                `px-4 py-2 rounded-full whitespace-nowrap text-sm font-medium transition
                ${
                  selected
                    ? "bg-blue-600 text-white"
                    : "bg-white dark:bg-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600"
                }`
              }
            >
              {tab}
            </Tab>
          ))}
        </Tab.List>

        {/* ======== TAB CONTENT ======== */}
        <Tab.Panels className="mt-4">
          {/* --------------------- PROFILE TAB --------------------- */}
          <Tab.Panel>
            <PanelAnimation>
              <CustomerProfileView
                role={role}
                cust_id={cust_id}
                token={token}
              />
            </PanelAnimation>
          </Tab.Panel>

          {/* --------------------- SERVICE TAB --------------------- */}
          <Tab.Panel>
            <PanelAnimation>
              <CustomerServiceView
                role={role}
                cust_id={cust_id}
                token={token}
              />
            </PanelAnimation>
          </Tab.Panel>

          {/* --------------------- INVOICE TAB --------------------- */}
          <Tab.Panel>
            <PanelAnimation>
              <CustomerInvoiceView
                role={role}
                cust_id={cust_id}
                token={token}
              />
            </PanelAnimation>
          </Tab.Panel>

          {/* --------------------- BILLABLE TAB --------------------- */}
          <Tab.Panel>
            <PanelAnimation>
              <BillableItemList role={role} cust_id={cust_id} token={token} />
            </PanelAnimation>
          </Tab.Panel>

          {/* --------------------- CREDIT TAB --------------------- */}
          <Tab.Panel>
            <PanelAnimation>
              <CustomerCreditLogsVieww
                role={role}
                cust_id={cust_id}
                token={token}
              />
            </PanelAnimation>
          </Tab.Panel>

          {/* --------------------- TRANSACTION TAB --------------------- */}
          <Tab.Panel>
            <PanelAnimation>
              <CustomerTransactionView
                role={role}
                cust_id={cust_id}
                token={token}
              />
            </PanelAnimation>
          </Tab.Panel>

          {/* --------------------- LOG TAB --------------------- */}
          <Tab.Panel>
            <PanelAnimation>
              <CustomerLogView cust_id={cust_id} token={token} />
            </PanelAnimation>
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}

/* Panel content animation wrapper */
function PanelAnimation({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25 }}
    >
      {children}
    </motion.div>
  );
}
